"use client";

import type { Sweepstake, SweepstakeDetails } from "@/app/_lib/apis/sweepstake";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  type SelectChangeEvent,
} from "@mui/material";
import { useRouter } from "next/navigation";

type SweepstakeSelectorProps = {
  sweepstakes: Sweepstake[];
  currentSweepstake?: SweepstakeDetails;
};

export function SweepstakeSelector({
  sweepstakes,
  currentSweepstake,
}: SweepstakeSelectorProps) {
  const router = useRouter();

  const handleSweepstakeChange = (event: SelectChangeEvent) => {
    const newQuestId = Number(event.target.value);
    router.push(`/rewards/tiers/${newQuestId}`);
  };

  if (sweepstakes.length === 0) {
    return null;
  }

  return (
    <FormControl variant="outlined">
      <InputLabel id="sweepstake-select-label">Weekly Draw</InputLabel>
      <Select
        labelId="sweepstake-select-label"
        id="sweepstake-select"
        value={currentSweepstake?.quest_id?.toString() || ""}
        onChange={handleSweepstakeChange}
        label="Weekly Draw"
      >
        {sweepstakes.map((sweep) => (
          <MenuItem key={sweep.quest_id} value={sweep.quest_id.toString()}>
            {new Date(sweep.valid_from).toLocaleDateString()} - {sweep.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
